'use client';

import { useEffect, memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ShippingAddressModalProps } from '@next-app/interface/Common';
import Conditional from '@next-app/components/Conditional';
import {
  applyPaypalCheckout,
  prepareGuestCheckout,
} from '@next-app/utils/paypalHelper';
import Button from '@next-app/components/elements/Button/Button';
import {
  selectDynSess,
  selectIsFurniture,
} from '@next-app/lib/features/InitSelectors';
import { PDPState } from '@next-app/lib/features/PDP/PDPSlice.interface';
import { googlePay, applePay } from '@next-app/constants/constants';
import DynamicModal from '@next-app/components/elements/DynamicModal/DynamicModal';

const ShippingAddressModal = (props: ShippingAddressModalProps) => {
  const session = useSelector((state: PDPState) => selectDynSess(state));
  const isFurniture = useSelector(selectIsFurniture);

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const dispatch = useDispatch();

  const onClick = (state: boolean) => async () => {
    setIsButtonDisabled(true);
    if (
      (props.paymentType && props.paymentType === applePay.APPLE_PAY) ||
      (props.paymentType && props.paymentType === googlePay.GOOGLE_PAY)
    ) {
      props.handleModalClick && props.handleModalClick(state);
      setIsButtonDisabled(false);
    } else {
      const body = {
        paypalCheckout: false,
        isPaypalFromCheckout: true,
        _dynSessConf: session,
        dispatch,
        isFurniture,
      };
      await prepareGuestCheckout(body);

      const payPalBody = {
        useRegistryAddress: state && props.isRegistryModal,
        useCTLAddress: state && !props.isRegistryModal,
        isPaypalFromCheckout: props.isCheckoutPage ?? false,
        _dynSessConf: session,
        dispatch,
        isFurniture,
      };

      const applyPayPalCheckoutPayloadResponse =
        await applyPaypalCheckout(payPalBody);
      if (applyPayPalCheckoutPayloadResponse.status === 'OK') {
        window.location.href = applyPayPalCheckoutPayloadResponse.redirectURL;
        return;
      }
    }
  };

  useEffect(() => {
    if (props.showModal) {
      window.scrollTo(0, 0);
      document.body.style.position = 'fixed';
      document.body.style.right = '0px';
      document.body.style.left = '0px';
    }
  }, [props.showModal]);

  return (
    <Conditional if={props.showModal}>
      <DynamicModal
        modalTitle={props.modalTitle}
        modalContentClass={`ll-medium`}
        onModalClose={() => {
          props.setShowModal(false);
          document.body.style.position = 'static';
        }}
      >
        <div style={{ padding: '14px 4px 4px' }}>
          <p>{props.modalBodyContent}</p>

          <div className="d-flex justify-content-md-end flex-md-row flex-column mt-3 gap-ll-3">
            <div>
              <Button
                customClass={`w-100 w-md-auto`}
                onClick={onClick(false)}
                name="No"
                variant="ternary"
                disabled={isButtonDisabled}
              >
                No
              </Button>
            </div>
            <div className={`position-relative`}>
              <Button
                onClick={onClick(true)}
                name="Yes"
                variant="primary"
                customClass={`w-100 w-md-auto`}
                disabled={isButtonDisabled}
              >
                Yes
              </Button>
            </div>
          </div>
        </div>
      </DynamicModal>
    </Conditional>
  );
};

export default memo(ShippingAddressModal);
